import { DefaultApi } from "@coeff/api";
import { message } from "antd";
import React, { useContext } from "react";

import {
  AlertContext,
  DMContext,
  EMContext,
  GSContext,
  IDContext,
  IPContext,
  IPPContext,
  RContext,
  WBContext,
} from "../types";
import { TokenManager } from "../utils/tokenManager";

export enum MSLoginMethod {
  SSO = "SSO",
  MSAL = "MSAL",
}

type MSAuthContext = {
  logout: () => void;
  loginMethod: MSLoginMethod;
};

export const TokenManagerContext = React.createContext<TokenManager | null>(null);

export const ApiClientContext = React.createContext<DefaultApi | null>(null);

export const MessageContext = React.createContext<typeof message | null>(null);

export const GasServerContext = React.createContext<GSContext | null>(null);

export const RootContext = React.createContext<RContext | null>(null);

export const DataManagerContext = React.createContext<DMContext | null>(null);

export const EventManagerContext = React.createContext<EMContext | null>(null);

export const ImportPreviewContext = React.createContext<IPContext | null>(null);

export const ImportPreviewPPressContext = React.createContext<IPPContext | null>(null);

export const ImportDetailsContext = React.createContext<IDContext | null>(null);

export const AlertDetailsContext = React.createContext<AlertContext | null>(null);

export const WritebackDetailsContext = React.createContext<WBContext | null>(null);

export const MSAuthContext = React.createContext<MSAuthContext | null>(null);

export type SqlGetSchemaCacheContextValue = {
  enableGetSchemaTablesViewsCache: boolean;
};

export const SqlGetSchemaCacheContext = React.createContext<SqlGetSchemaCacheContextValue | null>(
  null
);

export const useSqlGetSchemaCacheContext = (): SqlGetSchemaCacheContextValue | null =>
  useContext(SqlGetSchemaCacheContext);

export const useApiClient = () => useContext(ApiClientContext) as DefaultApi;

export const useMessage = () => useContext(MessageContext) as typeof message;

export const useGasServerContext = () => useContext(GasServerContext) as GSContext;

export const useRootContext = () => useContext(RootContext) as RContext;

export const useDataManagerContext = () => useContext(DataManagerContext) as DMContext;

export const useEventManagerContext = () => useContext(EventManagerContext) as EMContext;

export const useImportDetailsContext = () => useContext(ImportDetailsContext) as IDContext;

export const useImportPreviewContext = () => useContext(ImportPreviewContext) as IPContext;

export const useAlertDetailsContext = () => useContext(AlertDetailsContext) as AlertContext;

export const useWritebackDetailsContext = () => useContext(WritebackDetailsContext) as WBContext;

export const useMSAuth = () => useContext(MSAuthContext) as MSAuthContext;

export const useTokenManager = () => useContext(TokenManagerContext) as TokenManager;
